import React, { useState } from "react";
import { useForm } from "react-hook-form";

import { useAuth } from "../../../AuthenticationStore";

import isotipo from "../../../assets/images/isotipo.png";
import distintivo from "../../../assets/images/distintivo.png";
import screen1 from "../../../assets/images/screen1.gif";
import logoopa from "../../../assets/images/opa-footer.png";
import { proccessError } from "../../../components/utils/utils";

export const Login = () => {
  const { signin, errors, loadingUser, companyService } = useAuth();

  const { handleSubmit, register } = useForm();
  const [errorsSendEmail, setErrorsSendEmail] = useState([]);
  const [okSendEmail, setOkSendEmail] = useState(false);

  const onSubmit = async values => {

    setErrorsSendEmail([]);

    try {
      const request = await companyService.sendEmail(
        values.message,
        values.receiver,
        values.subject,
        values.contact,
      );
      
      if(request.result) {
        setOkSendEmail(true);
      } else {
        setErrorsSendEmail(proccessError(request));
      }
    } catch (err) {
      // proccessError
      if (err.response.data) {
        setErrorsSendEmail(proccessError(err.response.data));
      } else {
        setErrorsSendEmail(["Error, intente luego."]);
      }
    }
  };

  return (
    <div className="container-scroller">
      <section
        style={{
          backgroundColor: !process.env.REACT_APP_SANDBOX? "rgb(69,78,241)" : "#db2828",
          height: "3px",
          width: "100%"
        }}
      />

      <div className="container">
        <nav className="navigation">
          <a href="#/"><img src={distintivo} alt="Logo CD" style={{ width: "380px" }} /></a>
          <input className="menu-btn" type="checkbox" id="menu-btn" />
          <label className="menu-icon" htmlFor="menu-btn">
            <span className="navicon"></span>
          </label>
          <ul className="menu">
            <li>
              <a
                href="#/"
                disabled={loadingUser}
                onClick={signin}
                className="use-btn"
              >
                <i className="fa fa-user"></i> Ingresar
              </a>
            </li>
            <li>
              <a href="#/" className="use-btn" id="conocenosScroll">
                Conócenos
              </a>
            </li>
            <li>
              <a href="#/" className="use-btn" id="contactanosScroll">
                Contáctanos
              </a>
            </li>
          </ul>
        </nav>
        {loadingUser ? (
          <div className="my-3">
            <div className="alert alert-success" role="alert">
              Cargando perfil...
            </div>
          </div>
        ) : null}
        <div className="my-3">
          {errors && errors.server ? (
            <div className="alert alert-danger" role="alert">
              {errors.server}
            </div>
          ) : null}
        </div>
      </div>

      <header>
        <section className="hero">
          <div className="texture-overlay"></div>
          <div className="container">
            <div className="row hero-content">
              <div className="col-lg-6 col-md-12 col-xs-12">
                <h1 className="">
                  Nos comprometemos a llevar la mejor{" "}
                  <span>soluci&oacute;n</span> para tus clientes.
                </h1>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <h3
                  style={{
                    backgroundColor: !process.env.REACT_APP_SANDBOX? "rgb(73, 79, 237)" : "#db2828",
                    borderRadius: "10px",
                    color: "#FFF",
                    padding: "10px"
                  }}
                >
                  Gestionamos la colocación de créditos partiendo del análisis
                  de sistemas de riesgos (PR) e información
                  socio-económica-demográfica (SED), permitiendo realizar
                  segmentaciones y entregar a través de canales digitales, la
                  oferta idónea de crédito para tu cliente, y que este pueda
                  auto gestionarlo hasta el desembolso, en la comodidad de su
                  casa u oficina.
                </h3>
              </div>
            </div>
          </div>
        </section>
      </header>

      {!process.env.REACT_APP_SANDBOX? (<>
        <section className="conocenos" id="conocenos">
          <div className="texture-overlay"></div>
          <div className="container">
            <div className="row hero-content">
              <div className="offset-lg-6 col-lg-6 col-md-12 col-xs-12">
                <h2 className="">
                  Tus clientes tendrán atención 24 horas al día los 7 días de la semana, con aprobaciones y desembolsos de forma fácil, ágil y segura.
                </h2>
              </div>
            </div>
            <div className="row">
              <div className="offset-md-6 col-md-6">
                <h3 className="rowh3">
                  Nuestra plataforma de créditos digitales al instante permite la exposición
                  de créditos aprobados para que a través de unos simples pasos tus clientes
                  dispongan de su préstamo, nuestra solución es de acceso rápido, de uso simple
                  y confiable, brindando soluciones ágiles de crédito,  nuestros componentes son
                  innovadores para la optimización de la colocación créditos.
                </h3>
                <h4 className="rowh4"><b>Créditos Digitales al Instante</b> es una marca
                    con el sello OPA S.A.S, empresa colombiana, legalmente constituida y
                    enmarcada en cumplimiento de lo dispuesto en la legislación actual,
                    incluyendo la ley 1581 de 2012 y el decreto 1377 de 2013.</h4>
              </div>
            </div>
          </div>
        </section>

        <section className="features-intro">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6 nopadding features-intro-img">
                <div className="features-bg">
                  <div className="texture-overlay"></div>
                  <div className="features-img wp1 animated fadeInLeft">
                    <h1><i className="fa fa-cubes"></i> Así suplimos tus necesidades:</h1>
                  </div>
                </div>
              </div>
              <div className="col-md-6 nopadding">
                <div className="slider features-slider">
                  <input
                    name="input-slider"
                    id="input-slide-0"
                    type="radio"
                    className="input-slide input-slide-num"
                  />
                  <input
                    name="input-slider"
                    id="input-slide-1"
                    type="radio"
                    className="input-slide input-slide-num"
                  />
                  <input
                    name="input-slider"
                    id="input-slide-2"
                    type="radio"
                    className="input-slide input-slide-num"
                  />
                  <input
                    name="input-slider"
                    id="input-slide-3"
                    type="radio"
                    className="input-slide input-slide-num"
                  />
                  <input
                    name="input-slider"
                    id="input-slide-autoplay"
                    type="radio"
                    className="input-slide"
                    defaultChecked
                  />
                  <ul>
                    <li className="slide-0"></li>
                    <li className="slide-1"></li>
                    <li className="slide-2"></li>
                    <li className="slide-3"></li>
                  </ul>
                  <div className="slide-description">
                    <label className="slide-0">
                      <h1>VIRTUALIZACI&Oacute;N</h1>
                      <p>
                        Es una plataforma desarrollada en la automatización 
                        total del proceso de otorgamiento del crédito de consumo, 
                        descongestionando las oficinas físicas, aumentando la 
                        efectividad de las campañas y mejorando la productividad de la compañía.
                      </p>
                    </label>
                    <label className="slide-1">
                      <h1>AUTOGESTIÓN</h1>
                      <p>
                        Modelar campañas acorde al perfil de cada cliente para 
                        entregarle la mejor oferta de crédito. Disponible en tan sólo cuatro pasos.  
                      </p>
                    </label>
                    <label className="slide-2">
                      <h1>CERCANÍA</h1>
                      <p>
                        Establezca un vínculo con sus clientes a través de medios digitales, 
                        en su cotidianidad, ofreciendo una oferta constante para ellos sin oficinas, sin trámites, sin filas ni desplazamientos.
                      </p>
                    </label>
                    <label className="slide-3">
                      <h1>SIMPLICIDAD</h1>
                      <p>
                        CRÉDITOS DIGITALES consulta los  perfiles de riesgo, la información socio económica y demográfica, para crear:
                        <br></br>1.	Segmentos para definir campañas de mercados específicos.
                        <br></br>2.	Establecer metas y medir sus logros.
                        <br></br>3.	Realizar proceso de divulgación a través de notificaciones SMS/Mailing.
                        <br></br>4.	 Realizar seguimiento de la campaña a través de panel de control.
                      </p>
                    </label>
                  </div>
                  <div className="slider-arrow-prev">
                    <label className="slide-0" htmlFor="input-slide-0"></label>
                    <label className="slide-1" htmlFor="input-slide-1"></label>
                    <label className="slide-2" htmlFor="input-slide-2"></label>
                    <label className="slide-3" htmlFor="input-slide-3"></label>
                  </div>
                  <div className="slider-arrow-next">
                    <label className="slide-0" htmlFor="input-slide-0"></label>
                    <label className="slide-1" htmlFor="input-slide-1"></label>
                    <label className="slide-2" htmlFor="input-slide-2"></label>
                    <label className="slide-3" htmlFor="input-slide-3"></label>
                  </div>
                  <div className="slider-dot">
                    <label className="slide-0" htmlFor="input-slide-0"></label>
                    <label className="slide-1" htmlFor="input-slide-1"></label>
                    <label className="slide-2" htmlFor="input-slide-2"></label>
                    <label className="slide-3" htmlFor="input-slide-3"></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="features-list" id="features">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 style=
                  {{
                    color: "#454ef2",
                    fontSize: "2rem",
                    fontWeight: "600",
                    paddingBottom: "3rem",
                    textAlign: "center"
                  }}>Porque deberías adquirirla:
                </h1>
              </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="feature-icon">
                <i className="fa fa-cogs"></i>
              </div>
              <div className="feature-content">
                <h1 style={{ color: "#454ef2" }} >Evoluci&oacute;n</h1>
                <p>El desarrollo de nuevas tecnologías garantiza la veracidad y autenticidad de los documentos digitales.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-icon">
                <i className="fa fa-rocket"></i>
              </div>
              <div className="feature-content">
                <h1 style={{ color: "#454ef2" }} >Independencia</h1>
                <p>Las nuevas tendencias crean hábitos digitales donde la autogestión es crucial. </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-icon">
                <i className="fa fa-retweet"></i>
              </div>
              <div className="feature-content">
                <h1 style={{ color: "#454ef2" }} >Cambio</h1>
                <p>En la actualidad no podemos evadir la virtualización de la vida cotidiana.</p>
              </div>
            </div>
          </div> 
          <div className="row">
            <div className="col-md-4">
              <div className="feature-icon">
                <i className="fa fa-bolt"></i>
              </div>
              <div className="feature-content">
                <h1 style={{ color: "#454ef2" }} >Tiempo</h1>
                <p>Es nuestro activo más valioso, no debemos gastarlo en trámites burocráticos obsoletos que suponen modelos anteriores de gestión.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-icon">
                <i className="fa fa-shield"></i>
              </div>
              <div className="feature-content">
                <h1 style={{ color: "#454ef2" }} >Confianza</h1>
                <p>Sus clientes estarán tranquilos y seguros al usar nuestra plataforma de autogestión.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-icon">
                <i className="fa fa-graduation-cap"></i>
              </div>
              <div className="feature-content">
                <h1 style={{ color: "#454ef2" }} >Conocimiento</h1>
                <p>Conocer a su cliente le permitirá acercarse a él de manera más efectiva y hacerle posible sus sueños.</p>
              </div>
            </div>
          </div>         
        </div>
      </section>

        <section className="showcase">
          <div className="showcase-wrap">
            <div className="texture-overlay"></div>
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <div className="device">
                    <div className="device-content">
                      <div className="showcase-slider">
                        <ul className="slides" id="showcaseSlider">
                          <li>
                            <img src={screen1} alt="Device Content" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                    <h1 style={{ fontSize: "2rem" }}><b>Canal de desembolso.</b></h1>
                      <p>
                        Esta solicitud es 100% digital, donde eliges el monto que deseas de acuerdo a tu cupo aprobado y se desembolsa en tu cuenta de ahorros.
                        Solicita tu crédito en 4 simples pasos.
                      </p>
                      <blockquote className="team-quote">
                        {/*<div className="avatar"><img src={avatar} alt="User Avatar"></img></div>*/}
                        <p>
                          1.	Confírmanos tu identidad.<br/>
                          2.  Calcula tu crédito.<br/>
                          3. 	Selecciona donde se desembolsará.<br/>
                          4.  Diligencia una breve encuesta.
                        </p>
                      </blockquote>
                      <p style={{ color: "#ffce02", fontWeight: "800" }}>
                        <em>Y listo, ya tienes tu dinero disponible para que lo uses.</em>
                      </p>
                  </div>
              </div>
            </div> 
          </div>
        </section>
        <br/>
        <br/>

        <section className="content" id="contactanos">
          {errorsSendEmail.length > 0? (
            <div className="row">
              <div className="col-1"></div>
              <div className="col-10 alert alert-danger" role="alert">
                {errorsSendEmail.map((err, index) => (
                  <li key={index}>{err}</li>
                ))}
              </div>
              <div className="col-1"></div>
            </div>
          ): null}

          {okSendEmail? (
            <div className="row">
              <div className="col-1"></div>
              <div className="col-10 alert alert-success" role="alert">
                El mensaje ha sido recibido correctamente
              </div>
              <div className="col-1"></div>
            </div>
          ): null}

          <form onSubmit={handleSubmit(onSubmit)} hidden={okSendEmail} className="container">
            <div className="row">
              <h1 style=
                {{
                  color: "#454ef2",
                  fontSize: "2rem",
                  fontWeight: "600",
                  paddingBottom: "3rem",
                  textAlign: "center"
                }} className="col-md-12 text-center">Contáctanos
              </h1>
            </div>

              <div className="row" style={{ marginTop: "-3rem" }}>
                <div className="col">
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text" id="">
                      <i className="fa fa-fw fa-user"></i>
                      </span>
                    </div>
                    <input
                      placeholder="Nombre"
                      name="contact"
                      ref={register({
                        required: "Required"
                      })}
                      type="text"
                      className="form-control"
                    />
                  </div>
                </div>

                <div className="col">
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text" id="">
                      <i className="fa fa-fw fa-envelope"></i>
                      </span>
                    </div>
                    <input
                      placeholder="Correo"
                      name="receiver"
                      ref={register({
                        required: "Required"
                      })}
                      type="text"
                      className="form-control"
                    />
                  </div>
                </div>

                <div className="col">
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="">
                        <i className="fa fa-fw fa-pencil"></i>
                        </span>
                      </div>
                      <input
                        placeholder="Motivo"
                        name="subject"
                        ref={register({
                          required: "Required"
                        })}
                        type="text"
                        className="form-control"
                      />
                    </div>
                  </div>
              </div>
              <br></br>
              <div className="row">
                <div className="col text-center">
                  <textarea
                    name="message"
                    ref={register({
                      required: "Required"
                    })}
                    rows="10"
                    placeholder="Mensaje"
                    style={{ width: "100%", border: "2px solid rgb(185, 185, 185)", borderRadius: "5px", boxShadow: "1px 2px 10px rgba(69, 78, 242, 0.20)" }}
                  ></textarea>
                </div>
              </div>
              <div className="row" style={{ marginTop: "20px" }}>
              <div className="col-md-12 text-center">
                <button className="learn-btn" type="submit"><font></font>Enviar  <i className="fa fa-paper-plane"></i></button>
              </div>
            </div>
          </form> 
        </section>
      </>) : null}

      <footer style={{ backgroundColor: !process.env.REACT_APP_SANDBOX? "#454ef1" : "#db2828" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <h1 className="footer-logo">
                <img
                  src={isotipo}
                  alt="Créditos Digitales"
                  style={{ width: "10rem" }}
                />
              </h1>
              <p style={{ color: "#FFF" }}>
                2020 © Todos los derechos reservados{" "}
                <a href="https://www.opa.com.co/" target="_blank" rel="noopener noreferrer">
                  <img src={logoopa} alt="OPA S.A.S"></img>
                </a>
              </p>
            </div>
            <div className="col-md-7">
              <ul className="footer-nav">
                <li>
                  <p style={{ right: "-20rem", position: "relative", textAlign: "right", color: "aliceblue" }}>
                    <span><i className="fa fa-phone" style={{ paddingRight: "0.5rem" }}></i></span><b>Teléfonos:</b> (034) 6 04 35 79 / 315 257 42 03
                    <br></br>
                    <span><i className="fa fa-envelope" style={{ paddingRight: "0.5rem" }}></i></span><b>Email:</b> servicioalcliente@opa.com.co
                    <br></br>
                    <span><i className="fa fa-briefcase" style={{ paddingRight: "0.5rem" }}></i></span><b>Horarios de atención:</b> Lunes a Viernes de 8:00 a.m. a 6:00 p.m
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      <script src="%PUBLIC_URL%/vendors/js/min/scripts-min.js"></script>
    </div>
  );
};
